import React from "react";
import {
  Dashboard
} from "../../_websoc/_partials";
import NewDashboardPage from "./NewDashboardPage";

export function DashboardPage() {	
  return <Dashboard />;
}
